<div class="center d-flex flex-column">
  <mat-icon class="h1">error_outline</mat-icon>
  <br/>
  <!--  <h2 class="danger">{{msg}}</h2>-->
  <div i18n>Pripojenie bolo prerušené.</div>
  <div><span i18n>Pokračujte na </span>&nbsp;<a href="/ais/logout.do" i18n>prihlasovaciu stránku</a>.</div>
</div>
